import { useTranslation } from "react-i18next";


export const countries = () => {
  const { t } = useTranslation();

  const contries = [
    t('Afganistán'),
    t('Albania'),
    t('Alemania'),
    t('Andorra'),
    t('Angola'),
    t('Antigua y Barbuda'),
    t('Arabia Saudita'),
    t('Argelia'),
    t('Argentina'),
    t('Armenia'),
    t('Australia'),
    t('Austria'),
    t('Azerbaiyán'),
    t('Bahamas'),
    t('Bangladés'),
    t('Barbados'),
    t('Baréin'),
    t('Bélgica'),
    t('Belice'),
    t('Benín'),
    t('Bielorrusia'),
    t('Birmania/Myanmar'),
    t('Bolivia'),
    t('Bosnia y Herzegovina'),
    t('Botsuana'),
    t('Brasil'),
    t('Brunéi'),
    t('Bulgaria'),
    t('Burkina Faso'),
    t('Burundi'),
    t('Bután'),
    t('Cabo Verde'),
    t('Camboya'),
    t('Camerún'),
    t('Canadá'),
    t('Catar'),
    t('Chad'),
    t('Chile'),
    t('China'),
    t('Chipre'),
    t('Ciudad del Vaticano'),
    t('Colombia'),
    t('Comoras'),
    t('Corea del Norte'),
    t('Corea del Sur'),
    t('Costa de Marfil'),
    t('Costa Rica'),
    t('Croacia'),
    t('Cuba'),
    t('Dinamarca'),
    t('Dominica'),
    t('Ecuador'),
    t('Egipto'),
    t('El Salvador'),
    t('Emiratos Árabes Unidos'),
    t('Eritrea'),
    t('Eslovaquia'),
    t('Eslovenia'),
    t('España'),
    t('Estados Unidos'),
    t('Estonia'),
    t('Etiopía'),
    t('Filipinas'),
    t('Finlandia'),
    t('Fiyi'),
    t('Francia'),
    t('Gabón'),
    t('Gambia'),
    t('Georgia'),
    t('Ghana'),
    t('Granada'),
    t('Grecia'),
    t('Guatemala'),
    t('Guinea ecuatorial'),
    t('Guinea-Bisáu'),
    t('Guinea'),
    t('Guyana'),
    t('Haití'),
    t('Honduras'),
    t('Hungría'),
    t('India'),
    t('Indonesia'),
    t('Irak'),
    t('Irán'),
    t('Irlanda'),
    t('Islandia'),
    t('Islas Marshall'),
    t('Islas Salomón'),
    t('Israel'),
    t('Italia'),
    t('Jamaica'),
    t('Japón'),
    t('Jordania'),
    t('Kazajistán'),
    t('Kenia'),
    t('Kirguistán'),
    t('Kiribati'),
    t('Kuwait'),
    t('Laos'),
    t('Lesoto'),
    t('Letonia'),
    t('Líbano'),
    t('Liberia'),
    t('Libia'),
    t('Liechtenstein'),
    t('Lituania'),
    t('Luxemburgo'),
    t('Macedonia del Norte'),
    t('Madagascar'),
    t('Malasia'),
    t('Malaui'),
    t('Maldivas'),
    t('Malí'),
    t('Malta'),
    t('Marruecos'),
    t('Mauricio'),
    t('Mauritania'),
    t('México'),
    t('Micronesia'),
    t('Moldavia'),
    t('Mónaco'),
    t('Mongolia'),
    t('Montenegro'),
    t('Mozambique'),
    t('Namibia'),
    t('Nauru'),
    t('Nepal'),
    t('Nicaragua'),
    t('Níger'),
    t('Nigeria'),
    t('Noruega'),
    t('Nueva Zelanda'),
    t('Omán'),
    t('Países Bajos'),
    t('Pakistán'),
    t('Palaos'),
    t('Panamá'),
    t('Papúa Nueva Guinea'),
    t('Paraguay'),
    t('Perú'),
    t('Polonia'),
    t('Portugal'),
    t('Reino Unido'),
    t('República Centroafricana'),
    t('República Checa'),
    t('República del Congo'),
    t('República Democrática del Congo'),
    t('República Dominicana'),
    t('República Sudafricana'),
    t('Ruanda'),
    t('Rumania'),
    t('Rusia'),
    t('Samoa'),
    t('San Cristóbal y Nieves'),
    t('San Marino'),
    t('San Vicente y las Granadinas'),
    t('Santa Lucía'),
    t('Santo Tomé y Príncipe'),
    t('Senegal'),
    t('Serbia'),
    t('Seychelles'),
    t('Sierra Leona'),
    t('Singapur'),
    t('Siria'),
    t('Somalia'),
    t('Sri Lanka'),
    t('Suazilandia'),
    t('Sudán del Sur'),
    t('Sudán'),
    t('Suecia'),
    t('Suiza'),
    t('Surinam'),
    t('Tailandia'),
    t('Tanzania'),
    t('Tayikistán'),
    t('Timor Oriental'),
    t('Togo'),
    t('Tonga'),
    t('Trinidad y Tobago'),
    t('Túnez'),
    t('Turkmenistán'),
    t('Turquía'),
    t('Tuvalu'),
    t('Ucrania'),
    t('Uganda'),
    t('Uruguay'),
    t('Uzbekistán'),
    t('Vanuatu'),
    t('Venezuela'),
    t('Vietnam'),
    t('Yemen'),
    t('Yibuti'),
    t('Zambia'),
    t('Zimbabue')
  ];

  return contries;
}

export default countries;
